import { Typography } from "@mui/material";
import { ActivePosition } from "src/types/products";
import { getCurrency } from "src/utils/currencies";
import { fDecimalNumber } from "src/utils/formatNumber";

export default function PositionValue({ amount, currency }: ActivePosition) {
	return (
		<Typography variant='subtitle2'>{fDecimalNumber(amount) + getCurrency(currency)}</Typography>
	);
}
